import { IApplicationState } from '../../types/redux';

export function getIsNeedSelfEmployedConfirmation({ offersData }: IApplicationState) {
  return !!offersData.newbuildingBroker?.isNeedSelfEmployedConfirmation;
}
